(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/board-buttons-system.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/board-buttons-system.js');

'use strict';

svs.numbergames.game.views.BoardButtonsSystem = Marionette.View.extend({
  className: 'numbergames-board-buttons-system padding-bottom-2',
  regions: {
    huxfluxBoxRegion: '#huxfluxBoxRegion'
  },
  ui: {
    resetBtn: '.js-reset-board-btn',
    huxfluxBtn: '.js-huxflux-board-btn'
  },
  triggers: {
    'click @ui.resetBtn': 'clearBoard',
    'click @ui.huxfluxBtn': 'huxfluxBoard',
    'keydown @ui.huxfluxBtn': {
      event: 'keydownHuxfluxBtn',
      preventDefault: false,
      stopPropogation: false
    }
  },
  modelEvents: {
    'change:isEmpty number:added number:removed change:level': 'updateButtons'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }, svs.numbergames.accessibility.behaviors.UIFocusDisable 
  ],
  radioEvents: {
    'huxflux:start': 'huxfluxStarted',
    'huxflux:end': 'updateButtons',
    'huxflux:hidePopover': 'hidePopover'
  },
  template(data) {
    return svs.numbergames.game.templates.board_buttons_system(data);
  },
  templateContext() {
    return {
      invertedButton: !svs.numbergames.productMapping.isKeno(this.model.get('productId')) && !svs.numbergames.productMapping.isEurojackpot(this.model.get('productId')),
      transparentButton: !svs.numbergames.productMapping.isEurojackpot(this.model.get('productId'))
    };
  },
  initialize() {
    this.model = this.collection.getActive();
  },
  onBeforeAttach() {
    this.popoverContent = new svs.numbergames.game.views.SystemHuxfluxBox({
      model: this.collection.getActive()
    });
    this.popover = new svs.components.Popover(this.getUI('huxfluxBtn'), {
      content: this.popoverContent.render().$el,
      position: 'top',
      closeOnOutsideClick: true,
      offset: {
        top: 0,
        bottom: 0
      }
    });
  },
  onRender() {
    this.updateButtons();
  },
  onClearBoard(view, event) {
    svs.numbergames.game.logger.debug('views.BoardButtonsSystem clearBoard', event);
    this.collection.clearActive();
    this.trigger('disableUI', this.getUI('resetBtn'));
  },
  onKeydownHuxfluxBtn(view, event) {
    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        event.stopPropagation();
        this.isKeyboardNavigation = true;
        this.triggerMethod('huxfluxBoard', view, event);
        break;
      default:
    }
  },
  onHuxfluxBoard(view, event) {
    svs.numbergames.game.logger.debug('views.BoardButtonsSystem huxfluxBoard', event);
    this.popoverContent.render();
    this.popover.show();
  },
  updateButtons() {
    this.trigger('toggleUI', this.getUI('huxfluxBtn'), !this.canHuxflux());
    this.trigger('toggleUI', this.getUI('resetBtn'), this.model.get('isEmpty'));
    this.hidePopover();
  },
  huxfluxStarted() {
    this.trigger('disableUI', this.getUI('huxfluxBtn'));
    this.trigger('disableUI', this.getUI('resetBtn'));
    this.hidePopover();
  },
  hidePopover() {
    var _this$popover;
    if ((_this$popover = this.popover) !== null && _this$popover !== void 0 && _this$popover.visible()) {
      this.popover.hide();
      if (this.isKeyboardNavigation) {
        svs.numbergames.core.utils.ui.focusElement(this.getUI('huxfluxBtn'));
        this.isKeyboardNavigation = false;
      }
    }
  },
  canHuxflux() {
    if (this.model.has('numbersExtra')) {
      const numberSize = this.model.get('numbers').getManualNumbersLength();
      const numberExtraSize = this.model.get('numbersExtra').getManualNumbersLength();
      const _svs$numbergames$rule = svs.numbergames.rules.system.systemLimits({
          rules: svs.numbergames.game_model.rulesRadio.request('rules'),
          numberSize,
          numberExtraSize
        }),
        numbersLimits = _svs$numbergames$rule.numbersLimits,
        numbersExtraLimits = _svs$numbergames$rule.numbersExtraLimits;
      return !(numbersLimits.max === numberSize && numbersExtraLimits.max === numberExtraSize);
    }
    return this.model.get('numbers').canHuxflux();
  },
  onDestroy() {
    this.popoverContent.destroy();
  }
});

 })(window);